import React from 'react';
import styles from './AddInventoryDeviceModal.module.scss';
import Modal from '../../../Modal';

import type { SubmitHandler, UseFormMethods } from 'react-hook-form';

type AddInventoryDeviceModalProps<T = { deviceName: string }> = {
  onClose: () => void;
  handleSubmit: UseFormMethods<T>['handleSubmit'];
  onSubmit: SubmitHandler<T>;
  isSubmitting: boolean;
  register: UseFormMethods<T>['register'];
  errors: UseFormMethods<T>['errors'];
};

type FormValues = {
  deviceName: string;
};

const AddInventoryDeviceModal: React.FC<AddInventoryDeviceModalProps<FormValues>> = ({onClose, handleSubmit, onSubmit, isSubmitting, register, errors}) => {
    return (
        <Modal
            onBackdropClick={onClose}
            className={styles.modalContent}
        >
            <h1 className={styles.title}>Add Vehicle</h1>
            <form
                onSubmit={handleSubmit(onSubmit)}
                className={styles.form}
            >
                <label className={styles.label}>
                    Vehicle Name
                    <input
                        type='text'
                        id='deviceName'
                        name='deviceName'
                        ref={register()}
                        className={styles.input}
                        placeholder='Enter vehicle name'
                    />
                    {!!errors.deviceName && <p className={styles.errorMessage}>{errors.deviceName.message.replace(/device/gi, 'vehicle')}</p>}
                </label>
                <div className={styles.buttons}>
                    <button
                        type='button'
                        onClick={onClose}
                        className={styles.cancelButton}
                    >
                        Cancel
                    </button>
                    <button
                        type='submit'
                        className={styles.createButton}
                        disabled={isSubmitting}
                    >
                        Create
                    </button>
                </div>
            </form>
        </Modal>
    );
}

export default AddInventoryDeviceModal;